import request from '@/utils/request'

//获取安装记录列表
export function getInstallRecordList(params) {
    return request.get('/api-device/device/install-log/list', params)
}
